import * as React from 'react';
import Modal from '../_helpers/Default/Modal';
import styled from 'styled-components';
import { rem } from 'polished';
import { ChooseModal } from '../Cart/ChooseModal';
import { __ } from 'react-i18n';
import { DsiSvgIcon as SvgIcon, DsiIconType as IconType } from 'eshop-defaults';
import { theme } from '../../theme/theme';
import { CompareService } from 'eshop-defaults';

const BodyWrapper = styled.div`
  display: flex;
  gap: ${rem(20)};
`;

const BodyLeft = styled.div``;

const BodyRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(10)};
  justify-content: center;
`;

const BodyRightUp = styled.div``;

const BodyRightUpSuccess = styled(BodyRightUp)`
  color: ${({ theme }) => theme.colors.successColor};
`;

const BodyRightUpError = styled(BodyRightUp)`
  color: ${({ theme }) => theme.colors.dangerColor};
`;

const BodyRightDown = styled.div``;

interface Props {
  onClose: () => void;
  onReset: () => void;
  onRedirect: () => void;
  modalType: number;
}

function CompareModalWindow({
  onClose,
  onReset,
  onRedirect,
  modalType,
}: Props) {
  function renderAddedSingle() {
    return (
      <ChooseModal
        titleText={__('Porovnanie produktov')}
        enableCloseIcon={true}
        handleClose={() => {
          onClose();
        }}
        enableOutsideClick={true}
        body={
          <BodyWrapper>
            <BodyLeft>
              <SvgIcon
                width={48}
                height={48}
                icon={IconType.finishedOrder}
                alt={''}
                viewBox="0 0 48 48"
                fill={theme.colors.successColor}
                marginLeft={0}
              />
            </BodyLeft>
            <BodyRight>
              <BodyRightUpSuccess>
                {__('Produkt bol pridaný do zoznamu na porovnanie.')}
              </BodyRightUpSuccess>
              <BodyRightDown>
                {__(
                  'Pre zobrazenie porovnania produktov pridajte ďalší produkt rovnakého typu.',
                )}
              </BodyRightDown>
            </BodyRight>
          </BodyWrapper>
        }
      />
    );
  }

  function renderAddedModal() {
    const compareService = new CompareService();

    return (
      <ChooseModal
        titleText={__('Porovnanie produktov')}
        enableCloseIcon={true}
        handleClose={() => {
          onClose();
        }}
        enableOutsideClick={true}
        buttons={[
          {
            handleClick: () => {
              onClose();
            },
            text: __('Zavrieť'),
          },
          {
            handleClick: () => {
              onRedirect();
            },
            text:
              __('Zobraziť porovnanie') +
              ` (${compareService.getCompareProductCount()})`,
            backgroundColor: theme.colors.successColor,
            textColor: 'white',
          },
        ]}
        body={
          <BodyWrapper>
            <BodyLeft>
              <SvgIcon
                width={48}
                height={48}
                icon={IconType.finishedOrder}
                alt={''}
                viewBox="0 0 48 48"
                fill={theme.colors.stockCountAvailable}
                marginLeft={0}
              />
            </BodyLeft>
            <BodyRight>
              <BodyRightUpSuccess>
                {__('Produkt bol pridaný do zoznamu na porovnanie.')}
              </BodyRightUpSuccess>
            </BodyRight>
          </BodyWrapper>
        }
      />
    );
  }

  function renderNotCompatibleModal() {
    return (
      <ChooseModal
        titleText={__('Porovnanie produktov')}
        enableCloseIcon={true}
        handleClose={() => {
          onClose();
        }}
        enableOutsideClick={true}
        buttons={[
          {
            handleClick: () => {
              onClose();
            },
            text: __('Zavrieť'),
          },
          {
            handleClick: () => {
              onReset();
            },
            text: __('Pridať do porovnania'),
            backgroundColor: theme.colors.dangerColor,
            textColor: 'white',
          },
        ]}
        body={
          <BodyWrapper>
            <BodyLeft>
              <SvgIcon
                width={48}
                height={48}
                icon={IconType.xInCircle}
                alt={''}
                viewBox="0 0 48 48"
                marginLeft={0}
                fill="none"
              />
            </BodyLeft>
            <BodyRight>
              <BodyRightUpError>
                {__(
                  'Snažíte sa porovnať produkty, ktoré nemajú spoločné parametre',
                )}
              </BodyRightUpError>
              <BodyRightDown>
                {__(
                  'Pridaním produktu, odstránite aktuálne produkty z porovnania',
                )}
              </BodyRightDown>
            </BodyRight>
          </BodyWrapper>
        }
      />
    );
  }

  if (modalType === 1) {
    return renderAddedSingle();
  } else if (modalType === 2) {
    return renderAddedModal();
  } else if (modalType === 3) {
    return renderNotCompatibleModal();
  } else {
    return <></>;
  }
}

export default CompareModalWindow;
